<template>
    <page-container class="verify-result"
                    :class="{ 'content': !$route.query.hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!$route.query.hideNavigate && !$route.query.isUnlogin">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/verify' }"
                                replace>我要验签</el-breadcrumb-item>
            <el-breadcrumb-item><a>验签结果</a></el-breadcrumb-item>
        </el-breadcrumb>
        <div class="verify-result-content">
            <h2 class="text-center verify-title">
                <el-button type="text"
                           class="grey-text small-font back-button"
                           @click="$router.back()">&lt; 返回上一页</el-button>
                <span class="title-content">文件验签结果</span>
            </h2>
            <div class="result-content"
                 v-if="!signatoryCount">
                <p class="text-center tip no-result">抱歉，未查询到签名信息</p>
            </div>
            <div class="result-content"
                 v-else>
                <p class="second-title">文件名称：{{ result.fileName }}</p>

                <p class="second-title">文件有效性：{{ fileValidity }}</p>

                <p class="assential-information">
                    <span class="second-title">签名信息</span>
                    <span class="autograph-num">文件中共有 <span class="red-text">{{signatoryCount}}</span> 个签名</span>
                </p>
                <div class="show-message"
                     v-for="(message, index) in result.signatureInfos"
                     :key="index">
                    <div class="horizen-layer">
                        <div class="left-content">
                            <div class="contruct-body">
                                <p class="contruct-label">签章结果：</p>
                                <div class="contruct-text">
                                    <span
                                        :class="message.code? 'red-text': 'green-text'">
                                        {{message.code ? '经验证，本次签名无效' : hasCertRootChain(message) ? "经验证，本次签名有效，签章者身份有效性未知" : '经验证，本次签名有效'}}
                                    </span>
                                </div>
                            </div>
                            <div class="contruct-body">
                                <p class="contruct-label">签章人：</p>
                                <div class="contruct-text">
                                    {{ message.signatory }}
                                </div>
                            </div>
                            <div class="contruct-body">
                                <p class="contruct-label">颁发机构：</p>
                                <div class="contruct-text">
                                    {{ message.organization }}
                                </div>
                            </div>
                            <div class="contruct-body" v-if="message.cardNo">
                                <p class="contruct-label">签章人标识：</p>
                                <div class="contruct-text">
                                    {{ dataMasking(message.cardNo, message.signType) }}
                                </div>
                            </div>
                            <div class="contruct-body"
                                 v-if="message.signTime">
                                <p class="contruct-label">签名时间：</p>
                                <p class="contruct-text">{{ message.signTime }}
                                    <template v-if="message.hasOwnProperty('verifyTimestamp')">
                                        <span class="green-text"
                                              v-if="message.isVerify">(该时间为权威时间戳，经验证有效)</span>
                                        <span class="red-text"
                                              v-else>(该签名包含时间戳，经验证无效)</span>
                                    </template>
                                </p>
                            </div>

                            <div class="contruct-body">
                                <p class="contruct-label">是否使用时间戳：</p>
                                <div class="contruct-text">
                                    {{!message.hasOwnProperty('verifyTimestamp') ? '否' : '是'}}
                                </div>
                            </div>

                            <template v-if="message.strAlgName">
                                <div class="contruct-body">
                                    <p class="contruct-label">签名算法：</p>
                                    <div class="contruct-text">
                                        {{ message.strAlgName }}
                                    </div>
                                </div>

                                <div class="contruct-body">
                                    <p class="contruct-label">签名状态：</p>
                                    <div class="contruct-text">
                                        {{ !message.code ? '有效' : '已失效' }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="message.containSm2">
                                <div class="contruct-body" >
                                    <p class="contruct-label">签名算法：</p>
                                    <div class="contruct-text">
                                        SM2
                                    </div>
                                </div>

                                <div class="contruct-body">
                                    <p class="contruct-label">签名状态：</p>
                                    <div class="contruct-text">
                                        {{ message.sm2Verify ? '有效' : '已失效' }}
                                    </div>
                                </div>
                            </template>

                        </div>

                        <div class="right-content">
                            <h4 class="text-center">电子印章</h4>
                            <img :src="message.imgString">
                            <el-tag type="danger" size="mini" v-if="message.sealRecord">国办备案</el-tag>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </page-container>
</template>

<script>
import PageContainer from "../../components/container.vue";
import { openDB, getItem,deleteItem } from '@/api/indexedDB';

export default {
    name: "verifyResult",
    components: { PageContainer },
    data () {
        return {
            result: [], // 校验结果
            fileMessage: [] // 上传文件信息
        };
    },
    computed: {
        id () {
            return this.$route.query.id;
        },
        dbId () {
            return this.$route.query.dbId;
        },
        signatoryCount () {
            return this.result.signatureInfos && this.result.signatureInfos.length || 0;
        },
        // 是否已被修改
        isModified () {
            return this.result.signatureInfos && this.result.signatureInfos.some(signature => signature.statusCode);
        },
        fileValidity () {
            if (!this.result.signatureInfos.length) {
                return '文档无签章';
            } else if (this.result.signatureInfos.every(s => !s.code)) {
                return '签章文档有效';
            } else {
                return `签章文档已失效，${this.result.signatureInfos.filter(s => s.code).length}个章失效`;
            }
        }
    },
    mounted () {
        if (this.id) {
            this.getDetailFromApi(this.id);
        } else {
            this.handleFromUpload();
        }
    },
    methods: {
        // 存在且结果为false时，经验证，本次签名有效，签章者身份有效性未知
        hasCertRootChain(message) {
            if (message.hasOwnProperty('hasCertRootChain')) {
                return !message.hasCertRootChain;
            }
            return false;
        },
        // 处理来自上传接口的数据
        async handleFromUpload () {
            if (!this.id) {
               // this.fileMessage = JSON.parse(sessionStorage.getItem('fileMessage'));
               // this.result = this.fileMessage.response;
               const db = await openDB('fileDB', 1);
               const data = await getItem(db, 'fileStore', parseInt(this.dbId));
               console.log('Retrieved data from IndexedDB:', data); // 打印数据以检查结构
               this.result = data.response;
               const result = await deleteItem(db, 'fileStore', 1);
               console.log(result); // 打印删除结果
            }
            this.result.signatureInfos.forEach(signatory => {
                let isVerify = false; // 时间戳显示
                if (signatory.hasTimeStamp) {
                    if (signatory.verifyTimestamp) {
                        isVerify = true;
                    } else if (
                        signatory.hasOwnProperty("verifyTimestamp") &&
                        !signatory.verifyTimestamp
                    ) {
                        isVerify = false;
                    }
                }
                this.$set(signatory, 'isVerify', isVerify);
            });
        },

        // 获取来自详情
        async getDetailFromApi (id) {
            let loading = this.$loading({
                text: '数据加载中...'
            });
            try {
                let resp = await this.axios({
                    url: '/verify/detail',
                    method: 'GET',
                    params: { id }
                });
                resp = resp.data;
                this.result = resp;
                this.handleFromUpload();
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },
        dataMasking(val, type) {
            if (type === 'PERSONAL') {
                return val.slice(0, 6) + '***********' + val.slice(val.length - 1, val.length);
            } else {
                return val.slice(0, 8) + '***********' + val.slice(val.length - 1, val.length);
            }
        },
    }
};
</script>
<style lang="less" scoped>
.verify-result {
    .no-result {
        padding: 50px;
    }
    .horizen-layer {
        display: flex;
        justify-content: space-between;

        .right-content {
            position: relative;
            width: 260px;
            padding: 10px;
            height: 100%;
            img {
                margin: 10px auto;
                //width: 180px;
                max-width: 180px;
                max-height: 180px;
            }
            .el-tag {
                position: absolute;
                right: 6px;
                bottom: 20px;
            }
        }
        .left-content {
            width: e("calc(100% - 260px)");
        }
        .left-content {
            width: e("calc(100% - 260px)");
        }
    }
    .verify-result-content {
        padding: 0 50px;
        .verify-title {
            border-bottom: 1px solid @border-color-base;
            height: 80px;
            line-height: 80px;
            position: relative;

            .back-button {
                position: absolute;
                left: 0;
                top: 20px;
            }

            .title-content {
                display: inline-block;
                margin: 0 auto;
            }
        }
        .result-content {
            margin: 35px 0;
            .second-title {
                font-weight: bold;
                margin-bottom: 20px;
                font-size: 16px;
                color: #25303a;
            }
            .assential-information {
                margin: 30px 0 20px 0;
                .autograph-num {
                    font-size: 14px;
                    color: @grey;
                    display: inline-block;
                    margin-left: 12px;
                }
            }
            .show-message {
                background-color: @background-color-primary;
                border: 1px solid #e5e5e5;
                border-radius: 5px;
                margin-bottom: 30px;
                padding: 30px;
                .contruct-body {
                    display: flex;
                    margin: 10px 0 20px 0;
                    .contruct-label {
                        width: 140px;
                        text-align: left;
                        color: @grey;
                    }
                    .contruct-text {
                        flex: 1;
                        margin: 0;
                        img {
                            width: 200px;
                            vertical-align: middle;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.verify-result {
    font-size: 14px;
}
</style>
